import state from './state';
import actions from './actions';
import mutations from './mutations';

const ecofrostStore = {
  namespaced: true,
  state,
  actions,
  mutations
};

export default ecofrostStore;
